/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from "react";
import DataTable from 'react-data-table-component';
import {
  Input,
  Button,
  Radio,
  DatePicker,
  notification
} from "antd";
import butSearch from "../../../assets/icons/icon-but-search.png";
import Cookies from "js-cookie";
import "./custom-antd.css";
import moment from "moment";
import Api from "../../../services/ServiceApi";
import { connect } from "react-redux";
import { changeLang } from "../../../actions/langAction";
import { setDynamic } from "../../../actions/dynamicAction";
import 'moment/locale/th';
// import locale from 'antd/lib/locale/th_TH';

class VendorServiceCode extends Component {
/** JSON.parse(localStorage.getItem("companyData") */
  constructor(props) {
    super(props);
    this.state = {
      factUpdate: false,
      LangTranslate: [[]],
      title: "Service Code",
      vendorIDAdd: "",
      vendorDataList: [],
      serviceCodeAdd: "",
      serviceCostAdd: "",
      serviceNameAdd: "",
      vendorAreaNameRowAdd: "",
      areaDataList: [],
      vendorSubAreaNameRowAdd: "",
      subAreaDataList: [],
      vendorZoneNameRowAdd: "",
      vendorZoneDataList: [],

      areaZoneNameAdd: "",
      sapNoAdd: "",
      serviceTypeCodeAdd: "",

      payTypeAdd: "YES",
      statusAdd: 1,
      active: ["Inactive","Active"],

      companyID: Number(Cookies.get("companyid")),
      companyIDAdd: Number(Cookies.get("companyid")),
      companyDataList: JSON.parse(localStorage.getItem("companyData")),
      operatorID: Number(Cookies.get("operator_id")),
      projectID: Number(Cookies.get("project_id")),
      filterProjectdata: [],
      operatorData: [],
      projectData: [],

      operatorIDRowAdd: Number(Cookies.get("operator_id")),
      operatorDataRowAdd: [],
      filterProjectdataRowAdd: [],
      projectIDRowAdd: Number(Cookies.get("project_id")),
      projectDataRowAdd: [],
      jobTypeIDAdd: 0,
      jobTypeDataAdd: [],
      jobSubTypeIDAdd: 0,
      jobSubTypeDataAdd: [],
      displayRowJobType: "none",

      where: "",

      AddVendorGroupDisplay: "none",
      ConfirmDisplay: "none",
      dateFormat: "DD/MM/YYYY",
      EffectiveDateAdd: moment().toDate(),
      EffectiveDateAddFilter: moment(moment().toDate(),"DD/MM/YYYY"),
      ExpiryDateAdd: moment().toDate(),
      serviceID: 0,
      
      resultAddNewFail: false,
      resultAddNewText: "",
      actionVendorServiceCode: "Add",
      actionVendorServiceCodeButton: "Add",
      disableChangeValue: false,
      fillEffectiveDateDisplay: "none",
      displayRule: "block"

    };
  }

  async componentDidMount() {
    Api.post("master_language_detail_get", {
      company_id: Cookies.get("companyid"),
      page_id: 1,
    })
      .then((response) => {
        this.setState({
          LangTranslate: JSON.parse(
            response.data.data["masteR_LANGUAGE_DETAIL"][0].file_json
          ),
          factUpdate: true,
        });
      })
      .catch((e) => {
        console.log(e);
      });
    
      if (
        localStorage.getItem("projectData") === null ||
        localStorage.getItem("projectData") === undefined
      ) {
        this.logoutClicked();
      } else {
        const filterProjectdata = JSON.parse(
          localStorage.getItem("projectData")
        ).filter((data) => {
          //return data.operator_id == Cookies.get("operator_id");
          return data.operator_id == this.state.operatorID;
        });
        
        const filterProjectdataRowAdd = JSON.parse(
          localStorage.getItem("projectData")
        ).filter((data) => {
          return data.operator_id == this.state.operatorIDRowAdd;
        });
  
        this.setState({
          operatorData: JSON.parse(localStorage.getItem("operator")),
          projectData: filterProjectdata,
  
          operatorDataRowAdd: JSON.parse(localStorage.getItem("operator")),
          projectDataRowAdd: filterProjectdataRowAdd,
        });
      }      
      this.loadServiceCode();

      if(Number(Cookies.get("project_id")) == 7) this.setState({displayRule: "none"})
  }

  notify = (type, title, msg) => {
    const args = {
      message: title,
      description: msg,
      duration: 5,
      className: "font-thai-b",
    };
    notification[type](args);
  };

  loadArea = () => {
    Api.post("master_data/get_area_name", {
      "company_id" : this.state.companyIDAdd
    })
      .then((res) => {
        const { result, data } = res.data;
        if (result.value === "P") {
          this.setState({ areaDataList: data.result})
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  setCompanyAdd = (event) => {
    this.state.companyIDAdd = event.target.value;

    const filterOperatordataAdd = JSON.parse(
      localStorage.getItem("operator")
    ).filter((data) => {
      return data.company_id == event.target.value;
    });

    this.setState({
      operatorIDRowAdd: 0,
      operatorDataRowAdd: filterOperatordataAdd,
      projectIDRowAdd: 0,
      projectDataRowAdd: [],
      vendorIDAdd: 0,
      vendorZoneNameRowAdd: "",
      vendorZoneDataList:[],
      jobTypeIDAdd: 0,
      jobTypeDataAdd: [],
      jobSubTypeIDAdd: 0,
      jobSubTypeDataAdd: []
    })

    this.loadVendor();
    this.loadArea();
    this.loadZone();
    
  }
  
  setCompany = (event) => {
    const filterOperatordata = JSON.parse(
      localStorage.getItem("operator")
    ).filter((data) => {
      return data.company_id == event.target.value;
    });

    this.setState({
      companyID: event.target.value,
      operatorID: 0,
      operatorData: filterOperatordata,
      projectID: 0,
      projectData: [],

      companyIDAdd: event.target.value,
      operatorIDRowAdd: 0,
      operatorDataRowAdd: filterOperatordata,
      projectIDRowAdd: 0,
      projectDataRowAdd: [],
    })
  }

  setOperator = (event) => {
    this.setState({
      operatorID: event.target.value,
      operatorIDRowAdd: event.target.value
    });

    const filterProjectdata = JSON.parse(
      localStorage.getItem("projectData")
    ).filter((data) => {
      return data.operator_id == event.target.value;
    });

    this.setState({
      projectID: 0,
      projectData: filterProjectdata,
      projectIDRowAdd: 0,
      projectDataRowAdd: filterProjectdata,
    });

  }

  setSearchText = (event) => {
    this.setState({
      where: event.target.value
    })
  }

  onSearch = () => {    
    this.loadServiceCode();
  }

  loadServiceCode = () => {
    this.setState({filterDataList:[]});
    Api.post("master_data/get_vendor_service_code", {
      company_id: this.state.companyIDAdd,
      operator_id: this.state.operatorIDRowAdd,
      project_id: this.state.projectIDRowAdd,
      where: this.state.where,
    })
      .then((res) => {
        const { result, data } = res.data;
        if (result.code === "P") {
          const tmp = [];
          data.result.map((item, index) => (
          tmp.push({
            "serviceCode": <a title={item.service_code}>{item.service_code}</a>,
            "serviceCost": item.service_cost,
            "area": item.area_code,
            /*"subArea": item.sub_area_code,*/
            "zone": item.zone_code,
            "Lumpsum": item.lumpsumFlag,
            "status": <div className={"problem-type-"+this.state.active[item.is_active]}>{this.state.active[item.is_active]}</div>,
            "effectiveDate": this.displayDate(item.effective_date),
            "expiredDate": this.displayDate(item.expire_date),
            "Option":<button onClick={()=> this.clickEdit(item.company_id,item.operator_id,item.project_id,item.service_id,item.vendor_id, item.job_type_id, item.job_sub_type_id, item.area_code, item.sub_area_code, item.zone_code, item.area_zone_name, item.sap_no, item.service_type_code, item.service_code, item.service_cost, item.service_name, item.lumpsumFlag, item.is_active, item.effective_date,item.expire_date)} id={"btnEdit"+index} className="text-primary">edit</button>
            })
          ))
          this.setState({ filterDataList: tmp});
        }
      })
      .catch((e) => {
        console.log("error load get_vendor_service_code", e);
      });

      if((this.state.companyIDAdd == 3) && (this.state.operatorIDRowAdd == 4) && (this.state.projectIDRowAdd == 7)) {
        Api.post("V4/get_job_type", {
          company_id: this.state.companyIDAdd,
          operator_id: this.state.operatorIDRowAdd,
          project_id: this.state.projectIDRowAdd,
          pk_id: null,
          fk_id: null,
          is_active: 1,
          effective: 1,
          sql_where: null,
          UserName: Cookies.get("username"),
        })
          .then((res) => {
            this.setState({jobTypeDataAdd: res.data.data, jobTypeIDAdd: 0})
          })
          .catch((e) => {
            console.log("error loading job type", e);
          });
        this.setState({displayRowJobType: "block"})
      }else{
        this.setState({displayRowJobType: "none",jobTypeIDAdd: 0, jobSubTypeIDAdd: 0})
      }
      this.loadVendor();
      this.loadArea();
      Api.post("master_data/get_sub_area_name_v2", {
        "company_id" : this.state.companyIDAdd,
        "job_area_name" : this.state.vendorAreaNameRowAdd
      })
        .then((res) => {
          const { result, data } = res.data;
          if (result.value === "P") {
            this.setState({ subAreaDataList: data.result})
          }
        })
        .catch((e) => {
          console.log(e);
        });
      this.loadZone();
  }

  clickEdit = (company_id, operator_id, project_id, service_id, vendor_id, job_type_id, job_sub_type_id, area_code, sub_area_code, zone_code, area_zone_name, sap_no, service_type_code, service_code, service_cost, service_name, LumpsumFlag, is_active, effective_date, expire_date) => {
    const filterOperatordataAdd = JSON.parse(
      localStorage.getItem("operator")
    ).filter((data) => {
      return data.company_id == company_id;
    });

    const filterProjectdataRowAdd = JSON.parse(
      localStorage.getItem("projectData")
    ).filter((data) => {
      return data.operator_id == operator_id;
    });

    Api.post("master_data/get_vendor", {
      "company_id": company_id,
      "where" : ""
    })
    .then((res) => {
      const { result, data } = res.data;
      if (result.code === "P") {
        const tmp = [];
        data.result.map((item, index) => (
          tmp.push({
            "vendor_id": item.vendor_id,
            "vendor_name": item.vendor_name
          })
        ))
        this.setState({vendorDataList: tmp})
      }//
    })
    .catch((e) => {
      console.log("error add new vendor team group", e);
    })

    if((company_id == 3) && (operator_id == 4) && (project_id == 7)){
      this.setState({displayRowJobType: "block"})
      Api.post("V4/get_job_type", {
        company_id: company_id,
        operator_id: operator_id,
        project_id: project_id,
        pk_id: null,
        fk_id: null,
        is_active: 1,
        effective: 1,
        sql_where: null,
        UserName: Cookies.get("username"),
      })
        .then((res) => {
          this.setState({jobTypeDataAdd: res.data.data, jobTypeIDAdd: job_type_id})
        })
        .catch((e) => {
          console.log("error loading job type", e);
        });

        Api.post("get_job_sub_type", {
          job_sub_type_id : null,
          job_category_id : 2,
          job_type_id: job_type_id,
          is_active: 1,
          effective: 1,
          sql_where: " and company_id="+company_id,
          operator_id: operator_id
        })
          .then((res) => {
            this.setState({jobSubTypeDataAdd: res.data.data.job_sub_type_dto_list, jobSubTypeIDAdd: job_sub_type_id})
          })
          .catch((e) => {
            console.log("error loading job sub type", e);
          });

    }else{
      this.setState({displayRowJobType: "none", jobTypeIDAdd: 0, jobSubTypeIDAdd: 0})
    }
    console.log('area :'+area_code)
    Api.post("master_data/get_area_name", {
      "company_id" : company_id
    })
      .then((res) => {
        const { result, data } = res.data;
        if (result.value === "P") {
          this.setState({ areaDataList: data.result, vendorAreaNameRowAdd: area_code})
        }
      })
      .catch((e) => {
        console.log(e);
      });

    Api.post("master_data/get_sub_area_name_v2", {
      "company_id" : this.state.companyIDAdd,
      "job_area_name" : area_code
    })
      .then((res) => {
        const { result, data } = res.data;
        if (result.value === "P") {
          this.setState({ subAreaDataList: data.result, vendorSubAreaNameRowAdd: sub_area_code})
        }
      })
      .catch((e) => {
        console.log(e);
      });

    Api.post("master_data/get_zone_name", {
      "company_id" : company_id,
      "operator_id" : operator_id, 
      "project_id" : project_id
    })
      .then((res) => {
        const { result, data } = res.data;
        if (result.value === "P") {
          this.setState({ vendorZoneDataList: data.result})
          this.setState({vendorZoneDataList: data.result, vendorZoneNameRowAdd: zone_code})
        }
      })
      .catch((e) => {
        console.log(e);
      });

    this.setState({
      companyIDAdd: company_id,
      operatorIDRowAdd: operator_id,
      operatorDataRowAdd: filterOperatordataAdd,
      projectIDRowAdd: project_id,
      projectDataRowAdd: filterProjectdataRowAdd,
      serviceID: service_id,
      vendorIDAdd: vendor_id,
      areaZoneNameAdd: area_zone_name,
      sapNoAdd: sap_no,
      serviceTypeCodeAdd: service_type_code,
      serviceCodeAdd: service_code,
      serviceCostAdd: service_cost,
      serviceNameAdd: service_name,
      payTypeAdd: LumpsumFlag,
      statusAdd: is_active,
      EffectiveDateAdd:(effective_date != null)? this.displayDate(effective_date): "",
      EffectiveDateAddFilter: (effective_date != null)? this.displayDate(effective_date): "",
      ExpiryDateAdd: (expire_date != null)? this.displayDate(expire_date) : "",
      AddVendorGroupDisplay: "block",
      actionVendorServiceCode: "Edit",
      actionVendorServiceCodeButton: "Save"
    })

  }

  loadVendor(){
    Api.post("master_data/get_vendor", {
      "company_id": this.state.companyIDAdd,
      "where" : ""
    })
    .then((res) => {
      const { result, data } = res.data;
      if (result.code === "P") {
        const tmp = [];
        data.result.map((item, index) => (
          tmp.push({
            "vendor_id": item.vendor_id,
            "vendor_name": item.vendor_name
          })
        ))
        this.setState({vendorDataList: tmp})
      }//
    })
    .catch((e) => {
      console.log("error add new vendor team group", e);
    })
  }

  loadZone = () => {
    Api.post("master_data/get_zone_name", {
        "company_id" : this.state.companyIDAdd,
        "operator_id" : this.state.operatorIDRowAdd,
        "project_id" : this.state.projectIDRowAdd
    })
      .then((res) => {
        const { result, data } = res.data;
        if (result.value === "P") {
          this.setState({ vendorZoneDataList: data.result})
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  setOperatorRowAdd = (event) => {
    this.setState({
      operatorIDRowAdd: event.target.value
    });
  
    const filterProjectdataRowAdd = JSON.parse(
      localStorage.getItem("projectData")
    ).filter((data) => {
      return data.operator_id == event.target.value;
    });
  
    this.setState({
      projectIDRowAdd: "",
      projectDataRowAdd: filterProjectdataRowAdd,
    })
  }

  setProjectRowDataAdd = (event) => {
    this.state.projectIDRowAdd = event.target.value;
    this.loadZone();
    if((this.state.companyIDAdd == 3) && (this.state.operatorIDRowAdd == 4) && (this.state.projectIDRowAdd == 7)){
      this.setState({displayRule: "none", displayRowJobType: "block"});
      this.loadJobTypeDataAdd();
    }else{
      this.setState({displayRule: "block",jobTypeIDAdd: 0, jobTypeDataAdd: [], jobSubTypeIDAdd: 0, jobSubTypeDataAdd: [], displayRowJobType: "none"});
    }
  }

  setJobTypeDataAdd = (event) => {
    this.setState({
      jobTypeIDAdd: event.target.value
    })
    Api.post("get_job_sub_type", {
      job_sub_type_id : null,
      job_category_id : 2,
      job_type_id: event.target.value,
      is_active: 1,
      effective: 1,
      sql_where: " and company_id="+this.state.companyIDAdd,
      operator_id: this.state.operatorIDRowAdd
    })
      .then((res) => {
        this.setState({jobSubTypeDataAdd: res.data.data.job_sub_type_dto_list});
      })
      .catch((e) => {
        console.log("error loading job sub type", e);
      });
      
  }

  setJobSubTypeDataAdd = (event) => {
    this.setState({
      jobSubTypeIDAdd: event.target.value
    })
  }

  loadJobTypeDataAdd = () => {
    Api.post("V4/get_job_type", {
      company_id: this.state.companyIDAdd,
      operator_id: this.state.operatorIDRowAdd,
      project_id: this.state.projectIDRowAdd,
      pk_id: null,
      fk_id: null,
      is_active: 1,
      effective: 1,
      sql_where: null,
      UserName: Cookies.get("username"),
    })
      .then((res) => {
        this.setState({jobTypeDataAdd: res.data.data})
      })
      .catch((e) => {
        console.log("error loading job type", e);
      });
  }

  setStatus = (event) => {
    this.setState({
      statusAdd: event.target.value
    })
  }

  onAddVendorServiceCode = () => {
    this.setState({AddVendorGroupDisplay: "block"});
    
  }

  setProjectData = (event) => {
    if(event.target.value == 7){
      this.setState({
        displayRule: "none",
        displayRowJobType: "block",
        projectID: event.target.value,
        projectIDRowAdd: event.target.value
      })
    }else{
      this.setState({
        displayRule: "block",
        displayRowJobType: "none",
        projectID: event.target.value,
        projectIDRowAdd: event.target.value
      })
    }    
  };

  setVendorAdd = (event) => {
    this.setState({
      vendorIDAdd: event.target.value
    })
  }
  
  setAreaRowAdd = (event) => {
    this.setState({
      vendorAreaNameRowAdd: event.target.value
    })
    Api.post("master_data/get_sub_area_name_v2", {
      "company_id" : this.state.companyIDAdd,
      "job_area_name" : event.target.value
    })
      .then((res) => {
        const { result, data } = res.data;
        if (result.value === "P") {
          this.setState({ subAreaDataList: data.result})
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  
  setVendorSubAreaRowAdd = (event) => {
    console.log('sub area:'+event.target.value);
    this.setState({
      vendorSubAreaNameRowAdd: event.target.value
    })
    console.log('sub area:'+this.state.vendorSubAreaNameRowAdd);
  }
  
  setVendorZoneRowAdd = (event) => {
    this.setState({
      vendorZoneNameRowAdd: event.target.value
    })
  }

  setAreaZoneNameAdd = (event) => {
    this.setState({
      areaZoneNameAdd: event.target.value
    })
    console.log('area zone name:'+this.state.areaZoneNameAdd)
  }

  setSapNoAdd = (event) => {
    this.setState({
      sapNoAdd: event.target.value
    })
  }

  setServiceTypeCodeAdd = (event) => {
    this.setState({
      serviceTypeCodeAdd: event.target.value
    })
  }

  onChangeEffectiveDate = (date, dateString) =>{
    this.setState({
      EffectiveDateAdd: dateString,
      EffectiveDateAddFilter: moment(dateString,"DD/MM/YYYY")
    })
  }

  onChangeExpiryDate = (date, dateString) => {
    this.setState({
      ExpiryDateAdd: dateString
    })
  }

  onAddVendorGroup = () => {
    window.scrollTo(0, 0);
    if(this.state.AddVendorGroupDisplay == "none"){
      this.setState({
        AddVendorGroupDisplay: "block"
      })
    }else{
      this.setState({
        AddVendorGroupDisplay: "none"
      })
    }
  }

onCallConfirmWindow = () => {
  if(this.state.ConfirmDisplay == "none"){
    this.setState({ConfirmDisplay: "block"});
  }else{
    this.setState({ConfirmDisplay: "none", resultAddNewFail: false, AddVendorGroupDisplay: "none"})
  }
}

onResetFormAddNew = () => {
  this.onCallConfirmWindow();
  this.onCloseAddNewWindow();
  this.onAddVendorServiceCode();
}

onCloseAddNewWindow = () => {
  this.setState({
    vendorDataList: [],
    jobTypeDataAdd: [],
    jobSubTypeDataAdd: [],
    areaDataList: [],
    subAreaDataList: [],
    vendorZoneDataList: [],
    sapNoAdd: "",
    serviceTypeCodeAdd: "",
    AddVendorGroupDisplay: "none",
    actionVendorServiceCode: "Add",
    actionVendorServiceCodeButton: "Add"
  })
  this.loadServiceCode();
}

displayDate  = (data) => {
  if(data != null){
    const day = data.substring(0,10).split("-");
    return day[2] + "/" + day[1] + "/" + day[0];
  }
  return "-";
}

onCallConfirmWindowAndCallAddNewAgain = () => {
  this.onCallConfirmWindow();
  this.onAddVendorGroup();
}

ClickAction = (e) => {
  window.scrollTo(0, 0);
  const check = 0;
  if(this.state.projectIDRowAdd == 6){
    if(this.state.areaZoneNameAdd== ""){
      this.notify("info", "Informaton", "Please key area zone name before.");
      check = 1;
    }
    if(this.state.sapNoAdd == ""){
      this.notify("info", "Informaton", "Please key sap no. before.");
      check = 1;
    }
    if(this.state.serviceTypeCodeAdd == ""){
      this.notify("info", "Informaton", "Please key service type code before.");
      check = 1;
    }
  }
  e.preventDefault();
  if(this.state.EffectiveDateAdd == ""){
    this.setState({fillEffectiveDateDisplay:"block"});
  }else if(check == 0){
    
    this.setState({fillEffectiveDateDisplay:"none"});
    //# statement save data 
    (this.state.actionVendorServiceCode == "Add") ? 
    
      Api.post("master_data/insert_vendor_service_code", [{
        "company_id" : this.state.companyIDAdd,
        "operator_id" : this.state.operatorIDRowAdd,
        "project_id" : this.state.projectIDRowAdd,
        "job_type_id" : this.state.jobTypeIDAdd,
        "job_sub_type_id" : this.state.jobSubTypeIDAdd,
        "vendor_id" : this.state.vendorIDAdd,
        "area_code" : this.state.vendorAreaNameRowAdd,
        "sub_area_code" : this.state.vendorSubAreaNameRowAdd,
        "zone_code" : this.state.vendorZoneNameRowAdd,
        "area_zone_name" : this.state.areaZoneNameAdd,
        "sap_no" : this.state.sapNoAdd,
        "service_type_code" : this.state.serviceTypeCodeAdd,
        "service_code" : this.state.serviceCodeAdd,
        "service_cost" : this.state.serviceCostAdd,
        "service_name" : this.state.serviceNameAdd,
        "LumpsumFlag" : this.state.payTypeAdd,
        "is_active": this.state.statusAdd,
        "effective_date": moment(this.state.EffectiveDateAdd,"DD/MM/YYYY").format("YYYY-MM-DD"),
        "expire_date": (this.state.ExpiryDateAdd) != ''? moment(this.state.ExpiryDateAdd,"DD/MM/YYYY").format("YYYY-MM-DD"):null,
        "create_by": Cookies.get("userId")
    }])
      .then((res) => {
        console.log('Action: Add');
        const { result, data } = res.data;
        if (result.code === "P") {
          this.setState({AddVendorGroupDisplay: "none", resultAddNewFail: false, resultAddNewText:"เพิ่มข้อมูลเสร็จสิ้น"})
          this.onCloseAddNewWindow();
        }else{
          this.setState({AddProblemTypeDisplay : "none",resultAddNewFail: true,resultAddNewText:result.showText})
        }
        
        //#/** confirm 
        this.onCallConfirmWindow();
        this.onAddVendorServiceCode();

      })
      .catch((e) => {
        console.log("error insert_vendor_service_code", e);
      })
    : this.editData(e)
    
    //#/** statement save data 
  }
  
  e.stopPropagation();
}

editData = (e) => {
  console.log('Action: Edit');
  window.scrollTo(0, 0);
  e.preventDefault();
  if(this.state.EffectiveDateAdd == ""){
    this.setState({fillEffectiveDateDisplay:"block"});
  }else{
    this.setState({fillEffectiveDateDisplay:"none"});
    /** statement save data */
    Api.post("master_data/update_vendor_service_code", {
      "company_id" : this.state.companyIDAdd,
      "operator_id" : this.state.operatorIDRowAdd,
      "project_id" : this.state.projectIDRowAdd,
      "service_id" : this.state.serviceID,
      "job_type_id" : this.state.jobTypeIDAdd,
      "job_sub_type_id" : this.state.jobSubTypeIDAdd,
      "vendor_id" : this.state.vendorIDAdd,
      "area_code" : this.state.vendorAreaNameRowAdd,
      "sub_area_code" : this.state.vendorSubAreaNameRowAdd,
      "zone_code" : this.state.vendorZoneNameRowAdd,
      "area_zone_name" : (this.state.areaZoneNameAdd != null)? this.state.areaZoneNameAdd : "" ,
      "sap_no" : this.state.sapNoAdd,
      "service_type_code" : this.state.serviceTypeCodeAdd,
      "service_code" : this.state.serviceCodeAdd,
      "service_cost" : this.state.serviceCostAdd,
      "service_name" : this.state.serviceNameAdd,
      "LumpsumFlag" : this.state.payTypeAdd,
      "is_active": this.state.statusAdd,
      "effective_date": moment(this.state.EffectiveDateAdd,"DD/MM/YYYY").format("YYYY-MM-DD"),
      "expire_date": (this.state.ExpiryDateAdd) != ''? moment(this.state.ExpiryDateAdd,"DD/MM/YYYY").format("YYYY-MM-DD"):null,
      "update_by": Cookies.get("userId")
    })
      .then((res) => {
        const { result, data } = res.data;
        if (result.code === "P") {
          this.setState({AddVendorGroupDisplay: "none", resultAddNewFail: false, resultAddNewText: "แก้ไขข้อมูลเสร็จสิ้น"})
          this.onCloseAddNewWindow();
        }else{
          this.setState({AddVendorGroupDisplay : "none",resultAddNewFail: true, resultAddNewText:result.showText})
        }
        
        /** confirm */
        this.onCallConfirmWindow();
        this.loadServiceCode();

      })
      .catch((e) => {
        console.log("error editing service code", e);
      })
  }
}

/*8888888888888888888888888888*/
setVendorIDAdd = (event) => {
  this.setState({vendorIDAdd : event.target.value});
}

setServiceCodeAdd = (event) => {
  this.setState({serviceCodeAdd : event.target.value});
}

setServiceCostAdd = (event) => {
  this.setState({serviceCostAdd : event.target.value});
}

setServiceNameAdd = (event) => {
  this.setState({serviceNameAdd : event.target.value});
}

setAreaIDAdd = (event) => {
  this.setState({areaIDAdd : event.target.value});
} 

setPayTypeAdd = (event) => {
  this.setState({payTypeAdd : event.target.value});
}

render() {
  //console.log('company:'+this.state.companyDataList.auth);
  //console.log('company list:'+this.state.companyDataList["companyData"]);
  //console.log('Language:'+this.state.LangTranslate);
  const locale = Cookies.get("locale");
  const columns = [
    {
      name: (this.state.factUpdate)? this.state.LangTranslate[locale]["serviceCode"] : 'Service Code',
      selector: 'serviceCode',
      sortable: true,
    },
    {
      name: (this.state.factUpdate)? this.state.LangTranslate[locale]["serviceCost"] : 'Service Cost',
      selector: 'serviceCost',
    },
    {
      name: (this.state.factUpdate)? this.state.LangTranslate[locale]["areaName"] : 'Area',
      selector: 'area',
      sortable: true,
    },
    /*{
      name: (this.state.factUpdate)? this.state.LangTranslate[locale]["subAreaName"] : 'Sub Area',
      selector: 'subArea',
      sortable: true,
    },*/
    {
      name: (this.state.factUpdate)? this.state.LangTranslate[locale]["zoneName"] : 'Zone',
      selector: 'zone',
      sortable: true,
    },
    {
      name: 'Lump sum',
      selector: 'Lumpsum',
      sortable: true,
    },
    {
      name: (this.state.factUpdate)? this.state.LangTranslate[locale]["status"] : 'Status',
      selector: 'status',
    },
    {
      name: (this.state.factUpdate)? this.state.LangTranslate[locale]["EffectiveDate"] : 'Effective Date',
      selector: 'effectiveDate',
      sortable: true,
    },
    {
      name: (this.state.factUpdate)? this.state.LangTranslate[locale]["ExpiredDate"] : 'Expired Date',
      selector: 'expiredDate',
      sortable: true,
    },
    {
      name: (this.state.factUpdate)? this.state.LangTranslate[locale]["Action"] :'Action',
      selector: 'Option',
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      style: 'cursor:pointer'
    }
  ];

        return (
            <div>
                <span className="font-mont-r fs-12">Basic Data</span>
                <h3 className="font-mont-sb fs-18 c-blue">{this.state.title}</h3>
                <div className="w-100 box-search m-0">
                <div className="row">
                    <div>
                      <div className="title-search">Company</div>
                      <div>
                      <select 
                          placeholder="Please select Company"
                          className="dropdrowtype input-text-add-problem-type form-select"
                          onChange={(e)=>this.setCompany(e)}
                          value={this.state.companyID}
                          required
                        >
                          <option value="" className="please-select">PLEASE SELECT COMPANY</option>
                          {
                          this.state.companyDataList.map((item, index) => (
                            <option value={item.company_id} key={`layout_b_${index}`}>
                            {item.company_name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="pl-1">
                      <div className="title-search">Operator</div>
                      <div>
                        <select
                        placeholder="Please select Operator"
                        className="dropdrowtype input-text-add-problem-type form-select"
                        onChange={(e)=>this.setOperator(e)}
                        value={this.state.operatorID}
                      >
                        <option value="" className="please-select">PLEASE SELECT OPERATOR</option>
                        {this.state.operatorData.map((item, index) => (
                          <option
                            value={item.operator_id}
                            key={`layoutoption_${index}`}
                          >
                            {item.operator_name}
                          </option>
                        ))}
                        </select>
                      </div>
                    </div>
                    <div className="ml-2">
                      <div className="title-search">Project</div>
                      <div className="row">
                          <div>
                          <select
                              placeholder="Please select Project"
                              className="dropdrowtype input-text-add-problem-type form-select"
                              onChange={(e)=>this.setProjectData(e)}
                              value={this.state.projectID}
                            >
                              <option value="" className="please-select">PLEASE SELECT PROJECT</option>
                            {this.state.projectData.map((item, index) => (
                              <option value={item.project_id} key={`layout_b_${index}`}>
                                {item.project_name}
                              </option>
                            ))}
                          </select>
                          </div>
                          <div className="ml-2" style={{verticalAlign:"text-top"}}>
                            <div>
                              <Input
                                onChange={this.setSearchText}
                                placeholder="Search Vendor Name"
                                style={{ width: "150px" }}
                              />
                              <img type="button" src={butSearch} onClick={this.onSearch} className="but-search"/>
                            </div>
                          </div>
                      </div>
                    </div>
                    <div style={{paddingTop: "35px", right: "10px", display: "flex", position: "absolute"}}>
                      <button className="but-add-problem-type" onClick={this.onAddVendorServiceCode}>Add {this.state.title}</button>
                    </div>
                  </div>
                </div>
                
                <div className="box-content">
                    {/** load data */}
                    <DataTable 
                      style={{fontSize:"20px"}}
                      columns={columns}
                      data={this.state.filterDataList}
                      pagination
                      highlightOnHover
                    />
                </div>
              
                <div id="AddVendorServiceCodeWindow" className="add-new-window" style={{
                          position: 'absolute', top: '20%',
                          left: '50%',
                          marginLeft: '-260px',
                          display: this.state.AddVendorGroupDisplay
                      }}>
                  <form onSubmit={(e)=>this.ClickAction(e)}>
                  <div>
                    <div className="header-add-problem-type-window">{this.state.actionVendorServiceCode} {this.state.title}</div>
                    {/* row1 */}
                    <div className="row row-add">
                      <div className="col-sm-4 m-0 p-0">
                        <div className="title-add"><i className="data-important">*</i>Company</div>
                        <div>
                        <select 
                            placeholder="Please select Company"
                            className="dropdrowtype input-text-add-problem-type form-select"
                            onChange={(e)=>this.setCompanyAdd(e)}
                            style={{width:"154px"}}
                            value={this.state.companyIDAdd}
                            required
                          >
                            <option value="" className="please-select">PLEASE SELECT COMPANY</option>
                            {
                            this.state.companyDataList.map((item, index) => (
                              <option value={item.company_id} key={`layout_b_${index}`}>
                              {item.company_name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-sm-4 m-0 p-0">
                        <div className="title-add"><i className="data-important">*</i>Operator</div>
                        <div>
                        <select
                            className="dropdrowtype input-text-add-problem-type form-select"
                            onChange={(e)=>this.setOperatorRowAdd(e)}
                            value={this.state.operatorIDRowAdd}
                            style={{width:"154px"}}
                            required
                          >
                            <option value="" className="please-select"></option>
                            {this.state.operatorDataRowAdd.map((item, index) => (
                              <option
                                value={item.operator_id}
                                key={`layoutoption_${index}`}
                              >
                                {item.operator_name}
                              </option>
                            ))}
                            </select>
                        </div>
                      </div>
                      <div className="col-sm-4 m-0 p-0">
                        <div className="title-add"><i className="data-important">*</i>Project</div>
                        <div>
                        <select
                            className="dropdrowtype input-text-add-problem-type form-select"
                            onChange={(e)=>this.setProjectRowDataAdd(e)}
                            value={this.state.projectIDRowAdd}
                            style={{width:"154px"}}
                            required
                          >
                          <option value="" className="please-select"></option>
                          {this.state.projectDataRowAdd.map((item, index) => (
                            <option value={item.project_id} key={`layout_b_${index}`}>
                              {item.project_name}
                            </option>
                          ))}
                        </select>
                        </div>
                      </div>
                    </div>
                    {/* row 2 */}
                    <div className="row row-add">
                      <div className="col-sm-12 m-0 p-0">
                        <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["vendor"] : `Vendor`}</div>
                          <div>
                            <select 
                              id="vendorAdd"
                              placeholder="Please select Vendor"
                              className="dropdrowtype input-text-add-problem-type form-select"
                              onChange={(e)=>this.setVendorAdd(e)}
                              value={this.state.vendorIDAdd}
                              style={{width:"471px"}}
                              /*required*/
                            >
                              <option value="" className="please-select">PLEASE SELECT VENDOR</option>
                              {
                              this.state.vendorDataList.map((item, index) => (
                                <option value={item.vendor_id} key={`layout_b_${index}`}>
                                {item.vendor_name}
                                </option>
                              ))}
                              </select>
                          </div>
                        </div>
                    </div>
                    {/* row3 */}
                    <div className="row row-add">
                      <div className="col-sm-6 m-0 p-0" style={{display: this.state.displayRowJobType}}>
                        <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["jobType"] : `Job Type`}</div>
                        <div>
                          <select
                              id="JobTypeAdd"
                              placeholder="PLEASE SELECT JOB TYPE"
                              className="dropdrowtype select-problem-type form-select"
                              onChange={(e)=>this.setJobTypeDataAdd(e)}
                              value={this.state.jobTypeIDAdd}
                              style={{width:"230px"}}
                            >
                            <option value="" className="please-select"></option>
                            {this.state.jobTypeDataAdd.map((item, index) => (
                              <option value={item.job_type_id} key={`layout_b_${index}`}>
                                {item.job_type_name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-sm-6 m-0 p-0" style={{display: this.state.displayRowJobType}}>
                        <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["jobSubType"] : `Job Sub Type`}</div>
                        <div>
                        <select
                              id="JobTypeAdd"
                              placeholder="PLEASE SELECT JOB SUB TYPE"
                              className="dropdrowtype select-problem-type form-select"
                              onChange={(e)=>this.setJobSubTypeDataAdd(e)}
                              value={this.state.jobSubTypeIDAdd}
                              style={{width:"230px"}}
                            >
                            <option value="" className="please-select"></option>
                            {this.state.jobSubTypeDataAdd.map((item, index) => (
                              <option value={item.job_sub_type_id} key={`layout_b_${index}`}>
                                {item.job_type_name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    {/* row4 */}
                    <div className="row row-add">
                      <div className="col-sm-6 m-0 p-0">
                        <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["serviceCode"] : `Service Code`}</div>
                        <div>
                        <input type="text" onChange={this.setServiceCodeAdd} value={this.state.serviceCodeAdd} className="input-text-add-problem-type" required></input>
                        </div>
                      </div>
                      <div className="col-sm-6 m-0 p-0">
                        <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["serviceCost"] : `Service Cost`}</div>
                        <div>
                        <input type="number" onChange={this.setServiceCostAdd} value={this.state.serviceCostAdd} className="input-text-add-problem-type" style={{width: "190px"}} required></input> {(this.state.factUpdate)? this.state.LangTranslate[locale]["baht"] : `Baht`}
                        </div>
                      </div>
                    </div>

                    {/* row5 */}
                    <div className="row row-add">
                      <div className="col-sm-12 m-0 p-0">
                        <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["serviceName"] : `Service Name`}</div>
                        <div>
                        <input type="text" maxLength="500" onChange={this.setServiceNameAdd} value={this.state.serviceNameAdd} className="input-text-add-problem-type" required></input>
                        </div>
                      </div>
                    </div>
                    
                    {/* row6 */}
                    <div className="row row-add">
                      <div className="col-sm-4 m-0 p-0">
                        <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["Area"] : `Area`}</div>
                        <div>
                        <select 
                            className="dropdrowtype input-text-add-problem-type form-select mr-1"
                            onChange={(e)=>this.setAreaRowAdd(e)}
                            value={this.state.vendorAreaNameRowAdd}
                            style={{width:"154px"}}
                          >
                            <option value="" className="please-select"></option>
                            {
                            this.state.areaDataList.map((item, index) => (
                              
                              <option value={item.job_area_code} key={`layout_b_${index}`}>
                              {item.job_area_code}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-sm-4 m-0 p-0">
                        <div>
                          <div className="title-add">
                          <i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["subAreaName"] : 'Sub Area Name'}<br></br>
                          </div>
                          <select 
                            className="dropdrowtype input-text-add-problem-type form-select mr-1"
                            onChange={(e)=>this.setVendorSubAreaRowAdd(e)}
                            value={this.state.vendorSubAreaNameRowAdd}
                            style={{width:"154px"}}
                          >
                            <option value="" className="please-select"></option>
                            {
                            this.state.subAreaDataList.map((item, index) => (
                              
                              <option value={item.job_sub_area_code} key={`layout_b_${index}`}>
                              {item.job_sub_area_code}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-sm-4 m-0 p-0">
                        <div>
                          <div className="title-add">
                          <i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["zoneName"] : 'Zone Name'}<br></br>
                          </div>
                          <select 
                            className="dropdrowtype input-text-add-problem-type form-select mr-1"
                            onChange={(e)=>this.setVendorZoneRowAdd(e)}
                            value={this.state.vendorZoneNameRowAdd}
                            style={{width:"154px"}}
                          >
                            <option value="" className="please-select"></option>
                            {
                            this.state.vendorZoneDataList.map((item, index) => (
                              <option value={item.team_zone_name} key={`layout_b_${index}`}>
                              {item.team_zone_name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    {/* row7 */}
                    <div className="row row-add">
                      <div className="col-sm-6 m-0 p-0">
                        <div>
                          {
                            (this.state.displayRule == "none")?
                            <div className="title-add"><i className="data-important"></i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["areaZoneName"] : `Area Zone Name`}</div>
                            :
                            <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["areaZoneName"] : `Area Zone Name`}</div>
                          }
                        </div>
                        
                        <div>
                        <input type="text" value={this.state.areaZoneNameAdd} onChange={(e)=>this.setAreaZoneNameAdd(e)} className="input-text-add-problem-type" style={{width: "485px"}}></input>
                        </div>
                      </div>
                    </div>

                    {/* row8 */}
                    <div className="row row-add pt-3">
                      <div className="col-sm-6 m-0 p-0">
                        <div>
                        {(this.state.displayRule == "none")?
                        <div className="title-add">Sap No.</div>
                        :
                        <div className="title-add"><i className="data-important">*</i>Sap No.</div>
                        }
                        </div>
                        
                        <div><input  value={this.state.sapNoAdd} type="number" onChange={(e)=>this.setSapNoAdd(e)} className="input-text-add-problem-type"></input></div>
                      </div>
                      <div className="col-sm-6 m-0 p-0">
                        <div>
                        {(this.state.displayRule == "none")?
                        <div className="title-add">{(this.state.factUpdate)? this.state.LangTranslate[locale]["ServiceTypeCode"] : `Service Type Code`}</div>
                        :
                        <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["ServiceTypeCode"] : `Service Type Code`}</div>
                        }
                        </div>
                        
                        <div><input type="text" value={this.state.serviceTypeCodeAdd} onChange={(e)=>this.setServiceTypeCodeAdd(e)} className="input-text-add-problem-type"></input></div>
                      </div>
                    </div>

                    {/* row9 */}
                    <div className="row row-add">
                      <div className="col-sm-6 m-0 p-0">
                        <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["lumpSum"] : `Lump sum`}</div>
                        <div>
                        <Radio.Group defaultValue={this.state.payTypeAdd} value={this.state.payTypeAdd} onChange={this.setPayTypeAdd}>
                          <Radio value="YES">Yes</Radio>
                          <Radio value="NO">No</Radio>
                        </Radio.Group>
                        </div>
                      </div>                    
                      <div className="col-sm-6 m-0 p-0">
                        <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["status"] : `Status`}</div>
                      
                        <div>
                        <Radio.Group 
                          id="statusAdd"
                          name="statusAdd" 
                          defaultValue={this.state.statusAdd}
                          value={this.state.statusAdd}
                          onChange={(e)=>this.setStatus(e)}
                        >
                          <Radio value={1}>Active</Radio>
                          <Radio value={0}>Inactive</Radio>
                        </Radio.Group>
                        </div>
                      </div>
                    </div>

                    {/* row10 */}
                    <div className="row row-add">
                      <div className="col-sm-6 m-0 p-0">
                        <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["EffectiveDate"] : 'Effective Date'}</div>
                        <div><DatePicker style={{padding: 8}} onChange={this.onChangeEffectiveDate} value={(this.state.EffectiveDateAdd != '')? moment(this.state.EffectiveDateAdd, this.state.dateFormat):""} format={this.state.dateFormat}/>
                        <div style={{display: this.state.fillEffectiveDateDisplay, position: "absolute",color:"#FF0000"}}>Please fill effective date</div>
                        </div>
                      </div>
                      <div className="col-sm-6 m-0 p-0">
                        <div className="title-add">{(this.state.factUpdate)? this.state.LangTranslate[locale]["ExpiredDate"] : 'Expired Date'}</div>
                        <div><DatePicker style={{padding: 8}} onChange={this.onChangeExpiryDate}  value={(this.state.ExpiryDateAdd != '')? moment(this.state.ExpiryDateAdd, this.state.dateFormat):""} format={this.state.dateFormat} disabledDate={d => !d || d.isAfter(moment().add(100,"years")) || d.isSameOrBefore(this.state.EffectiveDateAddFilter)}/></div>
                      </div>
                    </div>

                    {/* row11 */}
                    <div className="row row-add">
                      <div className="col-sm-12 m-0 p-0 pt-3 text-center">
                        <Button onClick={this.onCloseAddNewWindow}>&nbsp;&nbsp;Cancel&nbsp;&nbsp;</Button>&nbsp;<button type="submit"  className="btn btn-primary-active" >&nbsp;&nbsp;&nbsp;{this.state.actionVendorServiceCodeButton}&nbsp;&nbsp;&nbsp;</button>
                      </div>
                    </div>

                  </div>
                </form>
                </div>

                <div id="ConfirmWindow" className="confirm-window" style={{
                          position: 'absolute', left: '50%', top: '20%',
                          transform: 'translate(-50%, -20%)',
                          display: this.state.ConfirmDisplay
                      }}>
                  <div className="row">
                    <div className="col-sm-12 m-0 p-3 text-center txt-confirm">
                      {this.state.resultAddNewText}
                    </div>
                  </div>
                  <div className="row row-add">
                    <div className="col-sm-12 m-0 p-0 text-center">
                      {
                        (this.state.actionVendorServiceCode == "Add")?
                          ((this.state.resultAddNewFail == true)? <Button type="primary" onClick={this.onCallConfirmWindowAndCallAddNewAgain}>&nbsp;&nbsp;{(this.state.factUpdate)? this.state.LangTranslate[locale]["butClose"] : `Close`}&nbsp;&nbsp;</Button> : <Button onClick={this.onResetFormAddNew}>&nbsp;&nbsp;&nbsp;เพิ่มอีกครั้ง&nbsp;&nbsp;&nbsp;</Button>):null
                      }&nbsp;&nbsp;
                      {
                        (this.state.resultAddNewFail == false)? <Button type="primary" onClick={this.onCallConfirmWindow}>&nbsp;&nbsp;ปิด&nbsp;&nbsp;</Button>:null
                      }
                    </div>
                  </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state) => ({
  lang: state.lang,
  dynamicReducer: state.dynamicReducer,
});
const mapDispacthToProps = (dispatch) => {
  return {
    changeLang: (data) => dispatch(changeLang(data)),
    setDynamic: (data, visible) => dispatch(setDynamic(data, visible)),
  };
};
export default connect(mapStateToProps, mapDispacthToProps)(VendorServiceCode);

